import { render, staticRenderFns } from "./HomeLivesImpacted.vue?vue&type=template&id=490ae1b2&scoped=true"
import script from "./HomeLivesImpacted.vue?vue&type=script&lang=ts"
export * from "./HomeLivesImpacted.vue?vue&type=script&lang=ts"
import style0 from "./HomeLivesImpacted.vue?vue&type=style&index=0&id=490ae1b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490ae1b2",
  null
  
)

export default component.exports